import { render, staticRenderFns } from "./HomePage.en.vue?vue&type=template&id=0b7f7688&"
import script from "./HomePage.en.vue?vue&type=script&lang=ts&"
export * from "./HomePage.en.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports